const features = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '1080P高清画质',
    desc: '采用先进编码技术，提供最高1080P全高清画质，香蕉视频、红桃视频等频道均支持高清播放，让每一帧都清晰锐利。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '多节点CDN智能加速，无论电信、移动还是联通网络，都能享受流畅不缓冲的播放体验，告别等待和卡顿。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '全平台适配',
    desc: '支持手机、平板、电脑全设备观看，蜜桃视频和91视频内容自动适配屏幕尺寸，随时随地畅享高清影视。',
  },
  {
    id: 4,
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '热门剧集、综艺播出后24小时内同步上线，追剧不再等待，全网最新影视资源尽在番茄视频。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">平台优势</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">为什么选择番茄视频？四大优势给你答案</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div key={feature.id} className="group bg-background-100 rounded-xl p-6 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer text-center">
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${feature.icon} text-primary-600 group-hover:text-background-50 text-2xl transition-colors`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}